import { Box, LinearProgress, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import i18n from '../../lang/idiomas'

const BarraPortesCasals = () => {
  const pedido = useSelector(state => state.pedidos.pedido)
  const user = useSelector(state => state.auth.user)
  const locale = useSelector(state => state.precios.locale)
  const moneda = useSelector(state => state.precios.moneda)

  const minPortes = parseFloat(user?.reservado_number_1 ?? 0)
  if (!minPortes) return null

  const totalPedido =
    pedido?.total_pedido != null
      ? parseFloat(pedido.total_pedido)
      : (pedido?.lineas
          ?.filter(l => l.tipo_linea === 'P')
          .reduce((acc, l) => acc + parseFloat(l.importe_neto_lin || 0), 0) ?? 0)

  const porcentaje = Math.min((totalPedido / minPortes) * 100, 100)
  const restante = Math.max(minPortes - totalPedido, 0)
  const alcanzado = totalPedido >= minPortes

  const formatear = importe =>
    new Intl.NumberFormat(locale, { style: 'currency', currency: moneda }).format(importe)

  return (
    <Box sx={{ my: 2 }}>
      <Typography
        variant='body2'
        sx={{ mb: 0.5 }}>
        {alcanzado ? (
          <span>
            {i18n.t('tarifa.portpaga')}: {formatear(minPortes)}.
          </span>
        ) : (
          <span>
            {i18n.t('tarifa.portrest')} <strong>{formatear(restante)}</strong> (
            {i18n.t('tarifa.portmini')} {formatear(minPortes)}).
          </span>
        )}
      </Typography>
      <LinearProgress
        variant='determinate'
        value={porcentaje}
        color={alcanzado ? 'success' : 'primary'}
        sx={{ height: 8, borderRadius: 4 }}
      />
    </Box>
  )
}

export default BarraPortesCasals
